import { NgModule } from '@angular/core';

import { DocumentPreloadDirective } from './document-preload.directive';
import { HoverTelemetryDirective } from './hover-telemetry.directive';
import { PreloadDirective } from './preload.directive';
import { WacHoverPrebootDirective } from './wac-hover-preboot.directive';

@NgModule({
    declarations: [
        DocumentPreloadDirective,
        PreloadDirective,
        HoverTelemetryDirective,
        WacHoverPrebootDirective
    ],
    exports: [
        DocumentPreloadDirective,
        PreloadDirective,
        HoverTelemetryDirective,
        WacHoverPrebootDirective
    ]
})
export class PreloadModule {
}
